import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MvPoleService } from 'shared-lib';
import {
  EditMvPole,
  MvPoleSave,
  PoleCondition,
  PoleShape,
  PoleStructure,
  PoleType,
} from 'shared-lib';
import { ToastrService } from 'ngx-toastr';
import { ImageType } from 'shared-lib';
import { BlobStorageService } from '../../../shared/_services/blob-storage.service';
import { Location } from '@angular/common';
import { AssetStatusEnum } from '../../../models/asset-status.model';
import { AssignTaskModalComponent } from '../../common/assign-task-modal/assign-task-modal.component';
import { ContainerNames } from '../../../models/container-names.model';
import { HistoryOutput } from '../../../models/history.model';
import { slideToggle } from '../../../helpers/slidetoggle';
import { EntityModelCustomizationService } from 'shared-lib';
import { EMCType } from '../../../enums/emc-type';
import { EntityModelConfiguration } from '../../../enums/entityModelConfiguration';
import { UtilitySharedService } from '../../../shared/_services/utility-shared.service';
import { AuthService } from 'shared-lib';
@Component({
  selector: 'app-edit-mv-pole',
  templateUrl: './edit-mv-pole.component.html',
  styleUrls: ['./edit-mv-pole.component.scss'],
  animations: [slideToggle],
  standalone: false,
})
export class EditMvPoleComponent implements OnInit {
  @ViewChild('closeModal') closeModal?: ElementRef;
  @ViewChild('closeAudit') auditReviewModal?: ElementRef;
  @ViewChild('openUpdateDescriptionModal')
  openUpdateDescriptionModal?: ElementRef;
  @ViewChild(AssignTaskModalComponent)
  assignTaskModalComponent!: AssignTaskModalComponent;
  id: number = 0;
  selectedMvPole: EditMvPole = new EditMvPole();
  headerExpanded: boolean = false;
  informationCardExpanded: boolean = true;
  devicesCardExpanded: boolean = true;
  networkInfoExpanded: boolean = true;
  userActivityExpanded: boolean = true;
  imagesExpanded: boolean = true;
  tagImageExpanded: boolean = true;
  MvPoleLeftImageExpanded: boolean = true;
  MvPoleRightImageExpanded: boolean = true;
  MvPoleCrossArmImageExpanded: boolean = true;
  selectedImage: string = '';
  mvPoleImage?: File | null;
  imgZoomFullContainer: any;
  currentRotation: number = 0;
  imgElement: any;
  isMapVisible: boolean = false;
  latitude: number = 0;
  longitude: number = 0;
  mvPoleType: string = '';
  mvPoleShape: string = '';
  mvPoleCondition: string = '';
  mvPoleStructure: string = '';
  AssetAssignType = AssetStatusEnum;
  assetAssignType?: AssetStatusEnum;
  ImageType = ImageType;
  editEnabled: boolean = false;
  showRecallMenu: boolean = false;
  isDropdownOpened: boolean = false;
  isDataQuality: boolean = false;
  recallAssignedAllowed: boolean = false;
  recallValidatedAllowed: boolean = false;
  fieldAgentSelected: boolean = false;
  history: HistoryOutput = new HistoryOutput();
  utilityId: number;
  EMCConfiguration: EntityModelConfiguration[] = [];
  EntityModelConfiguration = EntityModelConfiguration;
  hasCimDataIntegration: boolean = false;

  mvPoleTypeOptions = [
    {
      name: PoleType[PoleType.Concrete],
      value: 1,
      translation: 'MV_POLES.TYPE.CONCRETE',
    },
    {
      name: PoleType[PoleType.Wooden],
      value: 2,
      translation: 'MV_POLES.TYPE.WOODEN',
    },
    {
      name: PoleType[PoleType.Steel],
      value: 3,
      translation: 'MV_POLES.TYPE.STEEL',
    },
  ];

  mvPoleShapeOptions = [
    {
      name: PoleShape[PoleShape.Round],
      value: 1,
      translation: 'MV_POLES.SHAPE.ROUND',
    },
    {
      name: PoleShape[PoleShape.Square],
      value: 2,
      translation: 'MV_POLES.SHAPE.SQUARE',
    },
  ];

  mvPoleConditionOptions = [
    {
      name: PoleCondition[PoleCondition.Good],
      value: 1,
      translation: 'MV_POLES.CONDITION.GOOD',
    },
    {
      name: PoleCondition[PoleCondition.BentLeaning],
      value: 2,
      translation: 'MV_POLES.CONDITION.BENT',
    },
    {
      name: PoleCondition[PoleCondition.Vandalized],
      value: 3,
      translation: 'MV_POLES.CONDITION.VANDALIZED',
    },
  ];

  mvPoleStructureOptions = [
    {
      name: PoleStructure[PoleStructure.HPole],
      value: 1,
      translation: 'MV_POLES.STRUCTURE.HPOLE',
    },
    {
      name: PoleStructure[PoleStructure.Single],
      value: 2,
      translation: 'MV_POLES.STRUCTURE.SINGLE',
    },
    {
      name: PoleStructure[PoleStructure.ThreePoles],
      value: 3,
      translation: 'MV_POLES.STRUCTURE.THREE_POLES',
    },
    {
      name: PoleStructure[PoleStructure.FourPoles],
      value: 4,
      translation: 'MV_POLES.STRUCTURE.FOUR_POLES',
    },
  ];

  constructor(
    private mvPoleService: MvPoleService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private el: ElementRef,
    private blobStorageService: BlobStorageService,
    private renderer: Renderer2,
    private location: Location,
    private emcService: EntityModelCustomizationService,
    private utilitySharedService: UtilitySharedService,
    private authService: AuthService
  ) {
    this.hasCimDataIntegration = this.authService.hasCimDataIntegration;
  }

  ngOnInit(): void {
    this.utilityId = Number(this.utilitySharedService.getUtilityId());
    this.blobStorageService.setContainer(ContainerNames.Images);

    this.id = parseInt(this.route.snapshot.paramMap.get('id') || '');
    this.imgElement = this.el?.nativeElement?.querySelector(
      '.ngxImageZoomThumbnail'
    );
    this.imgZoomFullContainer =
      this.el?.nativeElement?.querySelector('.ngxImageZoomFull');
    this.getSelectedMvPole(this.id);
    this.getMvPoleEntityModelConfiguration();
  }

  private getMvPoleEntityModelConfiguration() {
    this.emcService.getConfigurationByType({type: EMCType.MvPole, utilityId: this.utilityId}).subscribe({
      next: (response: any) => {
        var data = response?.body?.data;
        this.EMCConfiguration = data.map((s: any) => EntityModelConfiguration[s as keyof typeof EntityModelConfiguration]);
      }
    })
  }

  getSelectedMvPole(id: number) {
    this.mvPoleService.getById(id).subscribe({
      next: (data) => {
        this.selectedMvPole = new EditMvPole(data?.body?.data);
        this.latitude = this.selectedMvPole.latitude;
        this.longitude = this.selectedMvPole.longitude;
        this.mvPoleType = this.mvPoleTypeOptions!.find(
          (x) => x.name == this.selectedMvPole.poleType
        )!.translation;
        this.mvPoleShape = this.mvPoleShapeOptions!.find(
          (x) => x.name == this.selectedMvPole.poleShape
        )!.translation;
        this.mvPoleCondition = this.mvPoleConditionOptions!.find(
          (x) => x.name == this.selectedMvPole.poleCondition
        )!.translation;
        this.mvPoleStructure = this.mvPoleStructureOptions!.find(
          (x) => x.name == this.selectedMvPole.poleStructure
        )!.translation;
        if (this.selectedMvPole.status === 'Assigned') {
          this.recallAssignedAllowed = true;
        }

        if (this.selectedMvPole.dataQualityId !== 0) {
          this.recallValidatedAllowed = true;
        }
      },
      error: (err) => {
        this.toastr.error('An error ocurred.');
      },
    });
  }

  showImage(type: ImageType) {
    switch (type) {
      case ImageType.MountedTag:
        this.selectedImage = this.getBuildingMountedImage() || '';
        break;
      case ImageType.MVPoleLeft:
        this.selectedImage = this.getMvPoleLeftImage() || '';
        break;
      case ImageType.MVPoleRight:
        this.selectedImage = this.getMvPoleRightImage() || '';
        break;
      case ImageType.MvPoleCrossArm:
        this.selectedImage = this.getMvPoleCrossArmImage() || '';
        break;
    }
  }

  getBuildingMountedImage() {
    return this.selectedMvPole.images?.find(
      (x) =>
        ImageType[x.imageType.toString() as keyof typeof ImageType] ==
        ImageType.MountedTag
    )?.url;
  }

  getMvPoleLeftImage() {
    return this.selectedMvPole.images?.find(
      (x) =>
        ImageType[x.imageType.toString() as keyof typeof ImageType] ==
        ImageType.MVPoleLeft
    )?.url;
  }

  getMvPoleRightImage() {
    return this.selectedMvPole.images?.find(
      (x) =>
        ImageType[x.imageType.toString() as keyof typeof ImageType] ==
        ImageType.MVPoleRight
    )?.url;
  }

  getMvPoleCrossArmImage() {
    return this.selectedMvPole.images?.find(
      (x) =>
        ImageType[x.imageType.toString() as keyof typeof ImageType] ==
        ImageType.MvPoleCrossArm
    )?.url;
  }

  fileBrowserHandler({
    file,
    type,
    imageId,
  }: {
    file: File;
    type: ImageType;
    imageId: number;
  }) {
    if (!file) {
      this.toastr.error('Image data is missing');
      return;
    }

    this.mvPoleImage = file;

    this.blobStorageService.uploadFile(
      this.mvPoleImage,
      this.mvPoleImage.name,
      (uploadedUrl) => {
        const obj = {
          imageType: type,
          poleId: this.selectedMvPole.id,
          guid: this.selectedMvPole.guid,
          url: uploadedUrl,
          imageId: imageId,
        };

        this.mvPoleService.uploadPicture(obj, this.mvPoleImage!).subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              const images = this.selectedMvPole.images.filter(
                (x) => x.imageType == type
              );
              const imageIndex = this.selectedMvPole.images.indexOf(
                images[imageId]
              );
              this.selectedMvPole.images[imageIndex] = responseData.data;
              this.toastr.success('Successfully added image');
              this.getSelectedMvPole(this.id);
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occurred while saving image metadata');
          },
        });
      },
      (error) => {
        console.error('Error uploading image to blob storage:', error);
        this.toastr.error('Failed to upload image to storage');
      }
    );
  }

  onModalFade() {
    this.currentRotation = 0;

    if (this.imgZoomFullContainer) {
      var displayValue = getComputedStyle(this.imgZoomFullContainer).display;

      if (displayValue == 'block') {
        this.imgElement.click();
      }
    }
  }

  rotateLeft() {
    this.currentRotation -= 90;
  }

  rotateRight() {
    this.currentRotation += 90;
  }

  onModalOpen() {
    this.renderer.setStyle(document.body, 'overflow', 'auto');
    this.renderer.setStyle(document.body, 'overflow-x', 'hidden');
    this.renderer.setStyle(document.body, 'padding-right', '0');
  }

  backClicked() {
    this.location.back();
  }

  onModalAssignFade() {
    this.assignTaskModalComponent.filterText = '';
    this.assignTaskModalComponent.isDropdownOpened = false;
  }

  openDropdown() {
    this.isDropdownOpened = true;
  }

  selectFieldAgent(id: number) {
    this.selectedMvPole.assignedUserId = id;
    this.fieldAgentSelected = true;
  }

  assignTask = (): void => {
    if (this.selectedMvPole.assignedUserId != 0 && this.fieldAgentSelected) {
      this.mvPoleService
        .assignPole(
          this.selectedMvPole.id,
          this.selectedMvPole.assignedUserId,
          this.assetAssignType!,
          this.isDataQuality
        )
        .subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              this.closeModal?.nativeElement?.click();
              this.toastr.success('Successfully assigned user');
              window.location.reload();
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occured');
          },
        });
    } else {
      this.toastr.warning('Please select valid user.');
    }
  };

  onAssignModalShown() {
    this.assignTaskModalComponent.title =
      this.assetAssignType == AssetStatusEnum.Retagged
        ? 'COMMON.RETAG_TASK'
        : 'COMMON.ASSIGN_AGENT';
    this.assignTaskModalComponent.submitText =
      this.assetAssignType == AssetStatusEnum.Retagged
        ? 'COMMON.RETAG'
        : 'COMMON.ASSIGN_TASK';
    this.assignTaskModalComponent.getMobileUsers();
  }

  recall() {
    this.mvPoleService.recall(this.id).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success('Successfully recalled MV Pole.');
          window.location.reload();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  cancelAuditReview() {
    this.auditReviewModal?.nativeElement?.click();
  }

  validateInput(event: Event) {
    if (!this.selectedMvPole.poleNumber) {
      this.toastr.error('MV Pole number can not be empty!');
      return;
    }
    if (!this.selectedMvPole.address) {
      this.toastr.error('MV Pole address can not be empty!');
      return;
    }

    this.openUpdateDescriptionModal?.nativeElement?.click();
  }

  updateHistory(history: any) {
    this.history = history;
    this.selectedMvPole.history = this.history;

    this.save();
  }

  save() {
    let saveModel = new MvPoleSave();
    saveModel.poleNumber = this.selectedMvPole.poleNumber;
    saveModel.poleType = this.selectedMvPole.poleType;
    saveModel.address = this.selectedMvPole.address;
    saveModel.closestLandmark = this.selectedMvPole.landmark;
    saveModel.poleShape = this.selectedMvPole.poleShape;
    saveModel.poleCondition = this.selectedMvPole.poleCondition;
    saveModel.poleStructure = this.selectedMvPole.poleStructure;
    saveModel.id = this.selectedMvPole.id;
    saveModel.history = this.selectedMvPole.history;

    this.mvPoleService.addOrUpdateMvPole(saveModel).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.editEnabled = false;
          this.toastr.success('Successfully edited pole');
          window.location.reload();
          this.openUpdateDescriptionModal?.nativeElement?.click();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
}
